import { Box, Button } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { headerColumnWidth } from './matrix/item/styled';

export const PermissionFooterStyled = styled(Box).attrs({
  py: { sm: '300' },
  pr: { sm: '300' },
  justifyContent: { sm: 'flex-end' },
})``;

export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.white};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const PermissionContainerStyled = styled(Box).attrs({
  mt: { sm: '400' },
  ml: { sm: '400' },
  mr: { sm: '300' },
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
})`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  position: relative;
  height: calc(100vh - 111px);
  overflow: hidden;
`;

export const PermissionFilterStyled = styled(Box).attrs({
  p: { sm: '400' },
  alignItems: { sm: 'center' },
  gap: { sm: '600' },
  justifyContent: { sm: 'space-between' },
})`
  width: 100%;
`;

export const FreezeCellStyled = styled(Box).attrs({
  p: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spacings[900]};
    left: 0;
    z-index: 1;
    width: ${headerColumnWidth};
    height: 44px;
    background-color: ${theme.colors.grey[100]};
    border: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const JumpToListStyled = styled(Box).attrs({})`
  ${({ theme }) => css`
    width: 60%;
    height: ${theme.spacings[800]};
    padding: ${theme.spacings[200]};
    color: ${theme.colors.grey[700]};
  `}
`;
export const ExpandAllStyled = styled(Box).attrs({
  p: { sm: '450' },
  gap: { sm: '400' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    width: 110px;
    height: 24px;
    cursor: pointer;
  `}
`;
